import React, { useState } from 'react';
import { pdf } from '@react-pdf/renderer';
import { 
  downloadPDF,
  condividiConShareAPI,
  condividiWhatsAppConPDF,
  condividiEmailConPDF
} from '../utils/shareUtils';
import '../styles/Condivisione.css';

function PulsantiCondivisionePDF({ 
  documentoPDF, 
  nomeFile, 
  testoCondivisione = '', 
  emailDestinatario = '',
  oggettoEmail = '',
  corpoEmail = ''
}) {
  const [loading, setLoading] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [blobPDF, setBlobPDF] = useState(null);

  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  const supportaShare = navigator.share !== undefined;

  async function apriMenu() {
  setLoading(true);
  try {

    const blob = await pdf(documentoPDF).toBlob();
    setBlobPDF(blob);
    setShowMenu(true);
  } catch (error) {
    alert('❌ Errore generazione PDF: ' + error.message);
  } finally {
    setLoading(false);
  }
}


  function chiudiMenu() {
    setShowMenu(false);
    setBlobPDF(null);
  }

  async function handleScarica() {
    try {
      downloadPDF(blobPDF, nomeFile);
      alert('✅ PDF scaricato!');
    } catch (error) {
      alert('❌ Errore: ' + error.message);
    }
    chiudiMenu();
  }

  async function handleCondividiApp() {
    setLoading(true);
    try {
      const result = await condividiConShareAPI(blobPDF, nomeFile, testoCondivisione);
      
      if (result.success) {
        alert('✅ PDF condiviso!');
      } else {
        alert(`ℹ️ ${result.error}\n\nProva con gli altri pulsanti.`);
      }
    } catch (error) {
      alert('❌ Errore: ' + error.message);
    } finally {
      setLoading(false);
      chiudiMenu();
    }
  }

  async function handleWhatsApp() {
    setLoading(true);
    try {
      const result = await condividiWhatsAppConPDF(blobPDF, nomeFile, testoCondivisione);
      
      if (result.success) {
        if (result.method === 'mobile-share') {
          alert('✅ PDF condiviso su WhatsApp!');
        } else {
          alert('✅ PDF scaricato!\n\n📱 Ora apri WhatsApp e allega il file dalla cartella Download.');
        }
      }
    } catch (error) {
      alert('❌ Errore: ' + error.message);
    } finally {
      setLoading(false);
      chiudiMenu();
    }
  }

  async function handleEmail() {
    setLoading(true);
    try {
      const oggetto = oggettoEmail || `Documento: ${nomeFile}`;
      const corpo = corpoEmail || `Ti invio il documento ${nomeFile}.\n\n${testoCondivisione}`;
      
      const result = await condividiEmailConPDF(
        blobPDF, 
        nomeFile, 
        emailDestinatario, 
        oggetto, 
        corpo
      );
      
      if (result.success) {
        if (result.method === 'mobile-share') {
          alert('✅ PDF condiviso via email!');
        } else {
          alert('✅ PDF scaricato!\n\n📧 Ora apri l\'email e allega il file dalla cartella Download.');
        }
      }
    } catch (error) {
      alert('❌ Errore: ' + error.message);
    } finally {
      setLoading(false);
      chiudiMenu();
    }
  }

  return (
    <>
      <button 
        className="btn-pdf"
        onClick={apriMenu}
        disabled={loading}
      >
        {loading ? '⏳' : <img src="/icon-pdf.svg" alt="pdf" style={{ width: '40px' }} />}
      </button>

      {showMenu && (
        <>
          <div className="condivisione-overlay" onClick={chiudiMenu}></div>
          <div className="condivisione-popup">
            <h4>Come vuoi condividere?</h4>
            
            <button 
              className="btn-condividi-opzione scarica"
              onClick={handleScarica}
              disabled={loading}
            >
              <img src="/icon-pdf.svg" alt="pdf" style={{ height: '30px' }} />
            </button>

            {supportaShare && (
              <button 
                className="btn-condividi-opzione condividi"
                onClick={handleCondividiApp}
                disabled={loading}
              >
                {loading ? '⏳' : ''} <img src="/icon-share.svg" alt="condividi" style={{ height: '30px' }} /> {isMobile ? '' : ''}
              </button>
            )}

            <button 
              className="btn-condividi-opzione whatsapp"
              onClick={handleWhatsApp}
              disabled={loading}
            >
              {loading ? '⏳' : ''} <img src="/icon-whatsapp.svg" alt="whatsapp" style={{ height: '30px' }} />
            </button>

            <button 
              className="btn-condividi-opzione email"
              onClick={handleEmail}
              disabled={loading}
            >
              {loading ? '⏳' : ''} <img src="/icon-email.svg" alt="email" style={{ height: '30px' }} />
            </button>

            <button 
              className="btn-condividi-opzione annulla"
              onClick={chiudiMenu}
              disabled={loading}
            >
              <img src="/icon-close.svg" alt="chiudi" style={{ height: '30px' }} />
            </button>
          </div>
        </>
      )}
    </>
  );
}

export default PulsantiCondivisionePDF;
